import { z } from "zod";

export const JustificationAppliesToEnum = {
  NSU: "NSU",
  DIVERGENCE: "DIVERGENCE",
  BOTH: "BOTH",
} as const;

export type JustificationAppliesTo = keyof typeof JustificationAppliesToEnum;

export const FormSchema = z.object({
  account_id: z
    .string({ required_error: "O campo é obrigatório." })
    .min(1, { message: "Deve ser um número maior ou igual a 1." }),
  name: z
    .string({ required_error: "O campo deve conter pelo menos 1 caractere." })
    .min(2, { message: "Deve ter pelo menos 2 caracteres." }),
  is_previous_day: z.boolean().default(false),
  is_next_day: z.boolean().default(false),
  applies_to: z.enum(["NSU", "DIVERGENCE", "BOTH"]).default("BOTH"),
  can_close_with_surplus: z.boolean().default(false),
});
